var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.94C10.6911 7.94 9.62998 9.00109 9.62998 10.31C9.62998 11.6189 10.6911 12.68 12 12.68C13.3089 12.68 14.37 11.6189 14.37 10.31C14.37 9.00109 13.3089 7.94 12 7.94ZM8.12998 10.31C8.12998 8.17266 9.86263 6.44 12 6.44C14.1373 6.44 15.87 8.17266 15.87 10.31C15.87 12.4473 14.1373 14.18 12 14.18C9.86264 14.18 8.12998 12.4473 8.12998 10.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0032 2.75C8.58648 2.74769 5.24462 4.73032 4.3514 8.65591C3.29434 13.3261 6.18806 17.3762 8.91017 19.9997C10.6407 21.661 13.3607 21.659 15.0791 20.0004L15.0805 19.999C17.8124 17.3756 20.7056 13.3354 19.6485 8.6656C18.76 4.73974 15.4202 2.75231 12.0032 2.75ZM21.1115 8.33441C20.04 3.60029 15.9848 1.25269 12.0042 1.25C8.0236 1.24731 3.96559 3.58953 2.88866 8.32364C1.64596 13.8131 5.07177 18.3836 7.86952 21.08L7.87047 21.0809C10.1799 23.2989 13.8191 23.3008 16.1204 21.08C18.9283 18.3834 22.3542 13.8239 21.1115 8.33441Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.13fcb13e49cf05a90d1530324d972873.svg";
export { ForwardRef as ReactComponent };